import { Page, usePage, useSurvey } from "@tree-company/tree-query";
import { Helmet } from "react-helmet";
import translate from "../locales";
import LogoOnzeEnergie from "../assets/images/logos/onze_energie_dark.svg";
import LogoNotreEnergie from "../assets/images/logos/notre_energie_dark.svg";
import { useContext } from "react";
import { LanguageContext, SurveyContext } from "../app";
import { Languages } from "@tree-company/collect-js-client";

export function Header({ page }: { page: Page }) {
  const language = useContext(LanguageContext);
  const survey = useContext(SurveyContext);

  const { title } = usePage(page);
  const { currentPageIndex, totalPages } = useSurvey(survey);
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <html lang={language}></html>
      </Helmet>
      <header className="page__header">
        {currentPageIndex > 0 && (
          <p className="page__number">
            {currentPageIndex}/{totalPages - 3}
          </p>
        )}
        <div className="page__header-content">
          <img
            src={language === Languages.fr ? LogoNotreEnergie : LogoOnzeEnergie}
            alt="Onze Energie"
            className="page__header-logo"
          />
          <span className="page__platform">
            {translate("layout.platform", {}, language)}
          </span>
        </div>
      </header>
    </>
  );
}
